import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ProgressionStep } from 'src/app/store/application';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnChanges {

  @Input() currentStep!: number | null;
  @Input() submissionInReview: boolean;
  @Output() goToPage = new EventEmitter<number>();
  @Output() goToBeginning = new EventEmitter();

  constructor() { }

  ngOnChanges(): void {
    const targetNode = this.submissionInReview ? ProgressionStep.ReviewPage : this.currentStep! - 1;
    this.performNodeCounterUpdate(targetNode);
  }

  performNodeCounterUpdate(targetNode: number): void {
    var nodeCounter: number = 0;

    document.querySelectorAll(".step-counter").forEach(node => {
      if (nodeCounter < targetNode) {
        node.innerHTML = `<i class="fas fa-check"></i>`;
        node.classList.remove('active');
        node.classList.add('completed');
        node.parentElement?.classList.add('parentComplete');

        if (this.submissionInReview) {
          node.classList.add("selectable");

          // if we are in the review phase and are at a previous page,
          // remove the checkmark from that page and the review page
          if (nodeCounter === this.currentStep! - 1 || nodeCounter === ProgressionStep.ReviewPage - 1) {
            node.innerHTML = "";
          }
        }

      } else if (nodeCounter === targetNode) {
        node.classList.add('active');
        node.parentElement?.classList.remove('parentComplete');

        if (this.submissionInReview) {
          node.classList.add("selectable");
        }

      } else {
        (node as any).innerText = '';
        node.classList.remove('active', 'completed', 'selectable');
        node.parentElement?.classList.remove('parentComplete');
      }

      nodeCounter++;
    });
  }

  goToStep(stepNumber: number) {
    if (!this.submissionInReview) {
      return;
    }

    this.goToPage.emit(stepNumber);
  }

  goToHome() {
    this.goToBeginning.emit();
  }
}
